import axiosInstance from "./axios-config";

const _get = (url = '', config = {}) => {
    return axiosInstance.get(url, config);
};

const _post = (url = '', data = {}, config = {}) => {
    return axiosInstance.post(url, data, config);
};

const _put = (url = '', data = {}, config = {}) => {
    return axiosInstance.put(url, data, config);
};

const _delete = (url = '', config = {}) => {
    return axiosInstance.delete(url, config);
};

export {
    _get,
    _post,
    _put,
    _delete
};